import { Routes } from "@angular/router";
import { OverviewComponent } from "./pages/overview/overview.component";
import { InvoicesComponent } from "./pages/invoices/invoices.component";
import { ClientsComponent } from "./pages/clients/clients.component";
import { authGuard } from "../auth/guards/auth.guard";
import { ProfileComponent } from "./pages/profile/profile.component";
import { CompaniesComponent } from "./pages/companies/companies.component";

export const DASHBOARD_ROUTES: Routes = [
    {
        path:'',
        redirectTo: 'overview',
        pathMatch:'full'
    },
    {
        path:'overview',
        component: OverviewComponent,
        canActivate: [authGuard],
        data: { title: 'Overview' }
    },
    {
        path:'invoices',
        component: InvoicesComponent,
        canActivate: [authGuard],
        data: { title: 'Invoices' }
    },
    {
        path: 'clients',
        component: ClientsComponent,
        canActivate: [authGuard],
        data: { title: 'Clients' }
    },
    {
        path: 'companies',
        component: CompaniesComponent,
        canActivate: [authGuard],
        data: { title: 'Companies'}
    },
    {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard],
        data: { title: 'Profile' }
    }
]